import {
    GET_USER_DATA,
    GET_USER_DATA_SUCCESS,
    GET_USER_DATA_ERROR,
    LOGOUT_USER,
    LOGOUT_USER_SUCCESS,
    LOGOUT_USER_ERROR,
    LOGIN_USER,
    LOGIN_USER_SUCCESS,
    LOGIN_USER_ERROR,
    CHANGE_PASS_USER,
    CHANGE_PASS_USER_ERROR,
    CHANGE_PASS_USER_SUCCESS,
    UPDATE_PROFILE_USER,
    UPDATE_PROFILE_USER_ERROR,
    UPDATE_PROFILE_USER_SUCCESS,
    SET_OBJECT
} from '../types';

//Cada reducer tiene su propio state
const initialState = {
    error: null,
    loading: false,
    user: null,
    authorities: null,
    accessToken: null,
    refreshToken: null,
    object: null
}

export default function(state = initialState, action) {
    switch(action.type){
        case GET_USER_DATA:
        case LOGIN_USER:
        case CHANGE_PASS_USER:
        case UPDATE_PROFILE_USER:
            return {
                ...state,
                loading: true
            }
        case LOGOUT_USER:
            return {
                ...state,
                loading: true,
                user: null,
                authorities: null,
                accessToken: null,
                object: null
            }
        case GET_USER_DATA_ERROR:
        case LOGIN_USER_ERROR:
        case LOGOUT_USER_ERROR:
        case CHANGE_PASS_USER_ERROR:
        case UPDATE_PROFILE_USER_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case LOGOUT_USER_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                user: null
            }
        case LOGIN_USER_SUCCESS:
        case GET_USER_DATA_SUCCESS:
        case CHANGE_PASS_USER_SUCCESS:
        case UPDATE_PROFILE_USER_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                accessToken: action.payload ? action.payload.accessToken : state.accessToken,
                refreshToken: action.payload ? action.payload.refreshToken : state.refreshToken,
                user: action.payload ? action.payload.usuario : state.user,
                authorities: action.payload ? action.payload.authorities : state.authorities
            }
        case SET_OBJECT:
            return {
                ...state,
                object: action.payload
            }
        default:
            return state;
    }
}